import { useMutation, useQueryClient } from "@tanstack/react-query";
import patchApiService from "../../services/patchApiService";
import { sitesEndpoint } from "../../constants/api-end-pionts";

export interface UpdateSiteCriticalValuePayload {
  id: string;
  name: string;
  criticalResistanceValue: number;
}

export const useUpdateSiteCriticalValue = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UpdateSiteCriticalValuePayload) => {
      return await patchApiService(sitesEndpoint, payload);
    },
    onSuccess: () => {
      // Invalidate queries so site lists, dashboard data, and sensor views refresh immediately
      queryClient.invalidateQueries({ queryKey: ["sites"] });
      queryClient.invalidateQueries({ queryKey: ["site_sensor_data"] });
      queryClient.invalidateQueries({ queryKey: ["dashboard"] });
      queryClient.invalidateQueries({ queryKey: ["dashBoard_data"] });
      queryClient.invalidateQueries({ queryKey: ["user_data"] });
      queryClient.invalidateQueries({ queryKey: ["all_sensors"] });
      queryClient.invalidateQueries({ queryKey: ["customer"] });
    },
  });
};
